module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ListHeader', {
    attrs: {
      "title": "Inscrições"
    }
  }), _vm._v(" "), _c('ListMain', [(true) ? _c('div', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-card', {
    staticClass: "el-card__search_list box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Pesquisar")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onFilter
    }
  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.onFilterClean
    }
  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Matrícula"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Filtrar por matrícula"
    },
    model: {
      value: (_vm.filters.ref_pessoa),
      callback: function($$v) {
        _vm.$set(_vm.filters, "ref_pessoa", $$v)
      },
      expression: "filters.ref_pessoa"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data da Inscrição"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "format": "dd/MM/yyyy",
      "placeholder": "Filtrar por data"
    },
    model: {
      value: (_vm.filters.dates),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dates", $$v)
      },
      expression: "filters.dates"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Filtrar Status",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.status_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status_id", $$v)
      },
      expression: "filters.status_id"
    }
  }, _vm._l((_vm.dependencies.status), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Modalidade"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Filtrar Modalidade",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.modality_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "modality_id", $$v)
      },
      expression: "filters.modality_id"
    }
  }, _vm._l((_vm.dependencies.modalities), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Lista de Inscrições")])]), _vm._v(" "), _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Modalidades")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.main_event.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.person.ref_pessoa) + " - " + _vm._s(item.person.pessoa.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.created_at)))]), _vm._v(" "), _c('td', _vm._l((item.modalities), function(modality) {
      return _c('div', [_vm._v(_vm._s(modality.event_modality.modality.name))])
    })), _vm._v(" "), _c('td', [_c('div', [_c('registration-status-label', {
      attrs: {
        "status-id": item.status_id,
        "status-name": item.status.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_vm._v("Última Atualização: " + _vm._s(_vm._f("dateTimeEnToBr")(item.status_updated_at)))])])])
  }))])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f7990b38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/registration/components/List.vue
// module id = 792
// module chunks = 2